import React, {ReactNode} from 'react';

import {makeReactContext} from 'lib/makeReactContext';

export interface ChatRenderContextValue {
  /**
   * When true, the chat UI is rendered for print/PDF export (static code blocks,
   * expanded tool panels, etc.) rather than interactive in-app chat.
   */
  isExportRender: boolean;
}

const getDefaultChatRenderContext = (): ChatRenderContextValue => ({
  isExportRender: false,
});

export const ChatRenderContext = makeReactContext(getDefaultChatRenderContext, 'ChatRenderContext');

const EXPORT_RENDER_VALUE: ChatRenderContextValue = {isExportRender: true};

export function ChatExportRenderProvider({children}: {children: ReactNode}): JSX.Element {
  return <ChatRenderContext.Provider value={EXPORT_RENDER_VALUE}>{children}</ChatRenderContext.Provider>;
}
